import React from 'react';
import PdfDeck from '../PdfDeck';

function Agra() {
  return <PdfDeck file='/machines-pdfs/mushroom_farm_agra.pdf' />;
}

export default Agra;
